export class PaginationDefaults {
  static readonly RowsPerPageOptions = [10, 25, 50];
  static readonly InitialRowsPerPage = 25;
}
